import * as React from "react";
import { makeIcon } from "./makeIcon";
const DuotoneLayers = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M0 5l8-5 8 5-8 5-8-5z", fill: "#fff" }),
    React.createElement("path", { d: "M0 11l8-5 8 5-8 5-8-5z", fill: "#fff", "fill-opacity": ".4" })));
export const DuotoneLayersIcon = makeIcon("duotoneLayers")(DuotoneLayers);
//# sourceMappingURL=DuotoneLayers.js.map